export default {
    create_company: {
        create: 'Create Company',
    },
    create_practice: {
        heading: 'Please provider a practice location',
        button: 'Proceed',
    },
}
